import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const usersConfirmationNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/confirmation/new",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "ResendConfirmationPage" */ "@circle-react/components/OnboardingPage/ResendConfirmationPage"
      ),
    "ResendConfirmationPage",
  ),
});
